// The review summary in the buy box links down to the testimonials. The
// custom block hardcodes a section id, which breaks whenever that section is
// removed and re-added, and the Judge.me badge is an app block whose markup
// cannot be edited at all. This finds the testimonials section at click time
// so neither problem matters.
//
// Original note: the Judge.me badge is an app block, so its markup
// cannot be edited. This intercepts the click and scrolls to the testimonials
// section instead. Delegated, because the badge is injected after load and
// the theme editor re-renders sections in place.
(function () {
  var BADGE = '.product-reviews-summary, .jdgm-prev-badge, .jdgm-preview-badge';
  var TESTIMONIALS = '[id*="testimonial"]';

  function findTarget() {
    var els = document.querySelectorAll(TESTIMONIALS);
    for (var i = 0; i < els.length; i++) {
      // Skip anything inside the buy box so the badge cannot match itself.
      if (!els[i].closest('[id^="ProductInfo-"]')) return els[i];
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target.closest) return;
      if (!event.target.closest(BADGE)) return;

      var target = findTarget();
      // No testimonials on this page - leave the default behaviour alone.
      if (!target) return;

      event.preventDefault();
      event.stopPropagation();

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });

      // Give the heading focus so the jump is announced to screen readers.
      var heading = target.querySelector('h2, h3');
      if (heading) {
        if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
        window.setTimeout(function () {
          heading.focus({ preventScroll: true });
        }, reduced ? 0 : 500);
      }
    },
    true
  );
})();
